/**
 * jsPDF-AutoTable plugin registration.
 *
 * WHY THIS FILE EXISTS
 * --------------------
 * Every PDF export in this app is written against the *plugin* form of the API:
 *
 *     const doc = new jsPDF(...);
 *     doc.autoTable({ head, body, ... });
 *
 * Up to jspdf-autotable@3 a bare `import 'jspdf-autotable'` was enough - the
 * package patched `jsPDF.API.autoTable` as an unconditional import side effect.
 *
 * jspdf-autotable@5 (required by the jspdf@4 upgrade that clears the CRITICAL
 * jsPDF advisories - obs #10 / CWE-1035) changed that. It now self-registers
 * ONLY when it can find a jsPDF constructor on `window`:
 *
 *     const jsPDF = anyWindow.jsPDF || anyWindow.jspdf?.jsPDF;
 *     if (jsPDF) { applyPlugin(jsPDF); }
 *                                       - dist/jspdf.plugin.autotable.mjs
 *
 * In a bundled Angular app jsPDF is an ES module import, never a window global,
 * so that branch never fires. The failure mode is SILENT and runtime-only:
 * every call site casts to `any` (`(doc as any).autoTable({...})`), so it
 * compiles clean and then throws "doc.autoTable is not a function" the first
 * time an officer clicks Export PDF.
 *
 * Importing this module registers the plugin against the same jsPDF class the
 * components import (webpack resolves 'jspdf' to one module instance), so the
 * existing `doc.autoTable(...)` call sites keep working unchanged.
 *
 * Import this INSTEAD of `import 'jspdf-autotable'`. It is deliberately not
 * done in main.ts: jspdf is only reachable from lazy-loaded dashboard/report
 * modules, and hoisting it into the bootstrap would drag ~400 kB of PDF code
 * into the initial bundle for every user, including those who never export.
 */
import { jsPDF } from 'jspdf';
import { applyPlugin } from 'jspdf-autotable';

applyPlugin(jsPDF);
